import {asText} from '@prismicio/client'
import {PrismicNextLink} from '@prismicio/next/pages'
import type {GlossaryTermDocument} from 'prismicio-types'

export interface TermListProps {
  groupedTerms: Record<string, Array<GlossaryTermDocument>>
}

export function TermList({groupedTerms}: TermListProps) {
  const sortedLetters = Object.keys(groupedTerms).sort()

  return (
    <div className="space-y-16">
      {sortedLetters.map((letter) => (
        <section key={letter} id={`letter-${letter}`} className="scroll-mt-36">
          <h2 className="mb-6 border-b border-dcdbda pb-2 text-40 font-semibold text-moss-black md:text-48">
            {letter}
          </h2>
          <ul className="list-none space-y-3">
            {groupedTerms[letter].map((term) => (
              <li key={term.uid}>
                <PrismicNextLink
                  document={term}
                  className="inline-block text-18 text-moss-grey-500 transition-colors hover:text-moss-grey-550 hover:underline hover:underline-offset-2"
                >
                  {asText(term.data.term)}
                </PrismicNextLink>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  )
}
